import { SurveyPage } from './survey/survey.page';
import { QuestionsPage } from './questions-pages/questions/questions.page';
import { QuestionDetailPage } from './questions-pages/question-detail/question-detail.page';
import { QuestionsCtrlPage } from './questions-pages/questions-ctrl/questions-ctrl.page';
import { AgendaWidgetPage } from './agenda-widget/agenda-widget.page';

export const PAGES = [
  SurveyPage, QuestionsPage, QuestionDetailPage, QuestionsCtrlPage, AgendaWidgetPage
];
